import gql from 'graphql-tag'

const GYM_MEMBERSHIP_DELETE =  gql`mutation ($membershipId: Int!){
    delete_three_gym_membership(where:{id: {_eq: $membershipId}})
    {
        affected_rows
    }
}`;    

const MA_MEMBERSHIP_DELETE =  gql`mutation ($membershipId: Int!){
    delete_three_ma_membership(where:{id: {_eq: $membershipId}})
    {
        affected_rows
    }
}`;    

const CLASS_MEMBERSHIP_DELETE =  gql`mutation ($membershipId: Int!){
    delete_three_class_membership(where:{id: {_eq: $membershipId}})
    {
        affected_rows
    }
}`; 

const STUDIO_MEMBERSHIP_DELETE =  gql`mutation ($membershipId: Int!){
    delete_three_studio_membership(where:{id: {_eq: $membershipId}})
    {
        affected_rows
    }
}`;    

const GYM_SCHEDULE_DELETE =  gql`mutation ($scheduleId: Int!){
    delete_three_gym_schedule(where:{id: {_eq: $scheduleId}})
    {
        affected_rows
    }
}`;    

const MA_SCHEDULE_DELETE =  gql`mutation ($scheduleId: Int!){
    delete_three_ma_schedule(where:{id: {_eq: $scheduleId}})
    {
        affected_rows
    }
}`;    

const CLASS_SCHEDULE_DELETE =  gql`mutation ($scheduleId: Int!){
    delete_three_class_schedule(where:{id: {_eq: $scheduleId}})
    {
        affected_rows
    }
}`;    

const STUDIO_SCHEDULE_DELETE =  gql`mutation ($scheduleId: Int!){
    delete_three_studio_schedule(where:{id: {_eq: $scheduleId}})
    {
        affected_rows
    }
}`;    



const GYM_MEMBERSHIP_TO_SCHEDULE_DELETE =  gql`mutation ($membershipToScheduleId: Int!){
    delete_three_gym_membership_to_schedule(where:{id: {_eq: $membershipToScheduleId}})
    {
        affected_rows
    }
}`;    

const MA_MEMBERSHIP_TO_SCHEDULE_DELETE =  gql`mutation ($membershipToScheduleId: Int!){
    delete_three_ma_membership_to_schedule(where:{id: {_eq: $membershipToScheduleId}})
    {
        affected_rows
    }
}`;    

const CLASS_MEMBERSHIP_TO_SCHEDULE_DELETE =  gql`mutation ($membershipToScheduleId: Int!){
    delete_three_class_membership_to_schedule(where:{id: {_eq: $membershipToScheduleId}})
    {
        affected_rows
    }
}`;

const STUDIO_MEMBERSHIP_TO_SCHEDULE_DELETE =  gql`mutation ($membershipToScheduleId: Int!){
    delete_three_studio_membership_to_schedule(where:{id: {_eq: $membershipToScheduleId}})
    {
        affected_rows
    }
}`;



const GYM_TO_SCHEDULE_DELETE =  gql`mutation ($membershipId: Int!, $scheduleId: Int!){
    delete_three_gym_membership_to_schedule(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {schedule_id: {_eq: $scheduleId}}
    ]})
    {
        affected_rows
    }
}`;    

const MA_TO_SCHEDULE_DELETE =  gql`mutation ($membershipId: Int!, $scheduleId: Int!){
    delete_three_ma_membership_to_schedule(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {schedule_id: {_eq: $scheduleId}}
    ]})
    {
        affected_rows
    }
}`;    

const CLASS_TO_SCHEDULE_DELETE =  gql`mutation ($membershipId: Int!, $scheduleId: Int!){
    delete_three_class_membership_to_schedule(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {schedule_id: {_eq: $scheduleId}}
    ]})
    {
        affected_rows
    }
}`;

const STUDIO_TO_SCHEDULE_DELETE =  gql`mutation ($membershipId: Int!, $scheduleId: Int!){
    delete_three_studio_membership_to_schedule(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {schedule_id: {_eq: $scheduleId}}
    ]})
    {
        affected_rows
    }
}`;


const GYM_FACILITY_DELETE =  gql`mutation ($membershipId: Int!, $facilityId: Int!){
    delete_three_gym_membership_facility(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {facility_id: {_eq: $facilityId}}
    ]})
    {
        affected_rows
    }
}`;    

const MA_FACILITY_DELETE =  gql`mutation ($membershipId: Int!, $facilityId: Int!){
    delete_three_ma_membership_facility(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {facility_id: {_eq: $facilityId}}
    ]})
    {
        affected_rows
    }
}`;    

const CLASS_FACILITY_DELETE =  gql`mutation ($membershipId: Int!, $facilityId: Int!){
    delete_three_class_membership_facility(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {facility_id: {_eq: $facilityId}}
    ]})
    {
        affected_rows
    }
}`;

const STUDIO_FACILITY_DELETE =  gql`mutation ($membershipId: Int!, $facilityId: Int!){
    delete_three_studio_membership_facility(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {facility_id: {_eq: $facilityId}}
    ]})
    {
        affected_rows
    }
}`;


const MA_CATEGORY_DELETE =  gql`mutation ($membershipId: Int!, $categoryId: Int!){
    delete_three_ma_membership_category(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {category_id: {_eq: $categoryId}}
    ]})
    {
        affected_rows
    }
}`;    

const CLASS_CATEGORY_DELETE =  gql`mutation ($membershipId: Int!, $categoryId: Int!){
    delete_three_class_membership_category(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {category_id: {_eq: $categoryId}}
    ]})
    {
        affected_rows
    }
}`;

const STUDIO_CATEGORY_DELETE =  gql`mutation ($membershipId: Int!, $categoryId: Int!){
    delete_three_studio_membership_category(where:{_and:[

        {membership_id: {_eq: $membershipId}},
        {category_id: {_eq: $categoryId}}
    ]})
    {
        affected_rows
    }
}`;

const USER_PUSH_SUBSCRIPTION_DELETE =  gql`mutation ($id: Int!){
    delete_user_push_subscription(where:{id: {_eq: $id}})
    {
        affected_rows
    }
}`;  

export default {
    
    gym_membership_delete: GYM_MEMBERSHIP_DELETE,

    ma_membership_delete: MA_MEMBERSHIP_DELETE,
    
    class_membership_delete: CLASS_MEMBERSHIP_DELETE,

    studio_membership_delete: STUDIO_MEMBERSHIP_DELETE,

    gym_schedule_delete: GYM_SCHEDULE_DELETE,

    ma_schedule_delete: MA_SCHEDULE_DELETE,
    
    class_schedule_delete: CLASS_SCHEDULE_DELETE,

    studio_schedule_delete: STUDIO_SCHEDULE_DELETE,

    gym_membership_to_schedule_delete: GYM_MEMBERSHIP_TO_SCHEDULE_DELETE,

    ma_membership_to_schedule_delete: MA_MEMBERSHIP_TO_SCHEDULE_DELETE,
    
    class_membership_to_schedule_delete: CLASS_MEMBERSHIP_TO_SCHEDULE_DELETE,

    studio_membership_to_schedule_delete: STUDIO_MEMBERSHIP_TO_SCHEDULE_DELETE,

    gym_to_schedule_delete: GYM_TO_SCHEDULE_DELETE,

    ma_to_schedule_delete: MA_TO_SCHEDULE_DELETE,
    
    class_to_schedule_delete: CLASS_TO_SCHEDULE_DELETE,

    studio_to_schedule_delete: STUDIO_TO_SCHEDULE_DELETE,

    gym_facility_delete: GYM_FACILITY_DELETE,

    ma_facility_delete: MA_FACILITY_DELETE,
    
    class_facility_delete: CLASS_FACILITY_DELETE,

    studio_facility_delete: STUDIO_FACILITY_DELETE,

    ma_category_delete: MA_CATEGORY_DELETE,
    
    class_category_delete: CLASS_CATEGORY_DELETE,

    studio_category_delete: STUDIO_CATEGORY_DELETE,

    user_push_subscription_delete: USER_PUSH_SUBSCRIPTION_DELETE
}